<a *ngIf="url" [attr.data-test]="'externalLink' + content" [attr.href]="url" target="_blank">{{ content }}</a>

<a *ngIf="!url" [attr.data-test]="'link' + content" xpo-link>{{ content }}</a>
